














import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * A box representing one step in a sequence of steps.
 */
@Component
export default class ProcessStepBox extends Vue {
  /** Step described by this element */
  @Prop({ type: Number, required: true }) step!: number;
  /** Currently active step */
  @Prop({ type: Number, required: true }) activeStep!: number;
  /** Title text */
  @Prop({ type: String, required: true }) title!: string;
  /** Show a loading indicator */
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  /** Style the box as interactive */
  @Prop({ type: Boolean, default: false }) selectable!: boolean;
  /** Stlye the box as containing an error */
  @Prop({ type: Boolean, default: false }) error!: boolean;

  get stateClass() {
    return {
      "is-inactive": this.activeStep !== this.step,
      "is-complete": this.activeStep > this.step,
      "is-loading": this.loading,
      "is-selectable": this.selectable,
      "is-danger": this.error
    };
  }
}
